import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S40BreadcrumbsSection } from '../components/interactive-sections/S40Breadcrumbs';
import { getPaddingInputs } from '../utils/builderSharedInputs';

Builder.registerComponent(S40BreadcrumbsSection, {
    name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S40Breadcrumbs,
    friendlyName: 'S40 Breadcrumbs',
    inputs: [
        ...getPaddingInputs(),
    ],
});
